"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLevelsPrizes = void 0;
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var useLevelsPrizes = function (data) {
    var locale = (0, next_intl_1.useLocale)();
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var currencyDependLocale = locale === 'ru' ? 'RUB' : currentCurrency;
    return data.map(function (level) {
        var _a, _b, _c, _d;
        var result = level;
        var bonus = Number(((_b = (_a = level === null || level === void 0 ? void 0 : level.bonusMaxBet) === null || _a === void 0 ? void 0 : _a.amount) === null || _b === void 0 ? void 0 : _b[currencyDependLocale]) || 0);
        if (bonus && bonus > 0) {
            result['maxBet'] = "".concat(bonus, " ").concat(currencyDependLocale);
        }
        var cash = Number(((_d = (_c = level === null || level === void 0 ? void 0 : level.instantReward) === null || _c === void 0 ? void 0 : _c.amount) === null || _d === void 0 ? void 0 : _d[currencyDependLocale]) || 0);
        if (cash && cash > 0)
            result['reward'] = "".concat(cash, " ").concat(currencyDependLocale);
        return result;
    });
};
exports.useLevelsPrizes = useLevelsPrizes;
